import { render, staticRenderFns } from "./selfWithdrawConfirm.vue?vue&type=template&id=1502c3f6&scoped=true"
import script from "./selfWithdrawConfirm.vue?vue&type=script&lang=js"
export * from "./selfWithdrawConfirm.vue?vue&type=script&lang=js"
import style0 from "./selfWithdrawConfirm.vue?vue&type=style&index=0&id=1502c3f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1502c3f6",
  null
  
)

export default component.exports